const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<blockquote class="
  wp-block-quote
  `);
                if ((context.has(`style`) ? context.get(`style`) : null)) {
                    this.echo(`is-style-`);
                    this.echo(this.env.getFilter('escape').traceableCallable(3, this.source)(...[this.env, (context.has(`style`) ? context.get(`style`) : null), `html`, null, true]));
                }
                this.echo(`  `);
                if ((context.has(`text_align`) ? context.get(`text_align`) : null)) {
                    this.echo(`has-text-align-`);
                    this.echo(this.env.getFilter('escape').traceableCallable(4, this.source)(...[this.env, (context.has(`text_align`) ? context.get(`text_align`) : null), `html`, null, true]));
                }
                this.echo(`  `);
                if ((context.has(`has_background`) ? context.get(`has_background`) : null)) {
                    this.echo(`has-gray-lighter-background-color has-background`);
                }
                this.echo(`">
  <p><b>CSS Grid Layout</b> excels at dividing a page into major regions or defining the relationship in terms of size, position, and layer, between parts of a control built from HTML primitives.</p>
  <p>Like tables, grid layout enables an author to align elements into columns and rows. However, many more layouts are either possible or easier with CSS grid than they were with tables. For example, a grid container's child elements could position themselves so they actually overlap and layer, similar to CSS positioned elements.</p>
  `);
                if ((context.has(`show_citation`) ? context.get(`show_citation`) : null)) {
                    this.echo(`    <cite><a href="https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Grid_Layout">MDN Web Docs</a></cite>
  `);
                }
                this.echo(`</blockquote>
`);
            }

            getTemplateName() {
                return `059aceefb0b2cbab720013997204b6ae01d5695f24e1b66bc9801c64384fce77`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `059aceefb0b2cbab720013997204b6ae01d5695f24e1b66bc9801c64384fce77`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '059aceefb0b2cbab720013997204b6ae01d5695f24e1b66bc9801c64384fce77');

let template = env.loadTemplate('059aceefb0b2cbab720013997204b6ae01d5695f24e1b66bc9801c64384fce77');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/quote.twig", args: context }
     );
     return rendered;;
};